import { Box } from "@mui/material";
import styled from "styled-components";
import laptopImg from "../../assets/images/Welcome_1440px.png";
import tabletImg from "../../assets/images/Welcome_700px.png";
import mobileImg from "../../assets/images/Welcome_550px.png";

export const FormContainerStyled = styled(Box)`
  padding: 31px 0;
`;

export const ContainerStyled = styled(Box)`
  height: 100vh;
  background-image: url(${laptopImg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 1024px) {
    /* Tablet view */
    background-image: url(${tabletImg});
  }

  @media (max-width: 768px) {
    /* Mobile view */
    background-image: url(${mobileImg});
  }

  .navbar-wrapper {
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 768px) {
      top: 15px;
      left: 15px;
    }
  }
`;
